module.exports = __webpack_public_path__ + "img/tentaculob.60c9a174.png";